/**
 * الإعدادات التجارية — عدّل من هنا فقط.
 * ⚠️ الأرقام أدناه مبدئية: استبدلها ببياناتك الحقيقية قبل النشر
 *    (السعر، رقم الواتساب، رقم الهاتف، عدد التقييمات، الكمية المتوفرة).
 */
export const PRODUCT = {
  currency: "₪",
  oldPrice: 220, // سعر المرساة (قبل الخصم)
  price: 149, // سعر القطعة الحالي
  whatsapp: "972592504624", // بصيغة دولية بدون + وبدون مسافات
  phone: "+972 59 250 4624",
  stockLeft: 7, // متبقي من دفعة العرض — حدّثه يدوياً
  customersCount: 1168,
};

/** حسابات التواصل الرسمية — مصدر واحد يستعمله الفوتر وبيانات المنظمة للمحرّكات */
export const SOCIAL = {
  facebook: "https://www.facebook.com/profile.php?id=61593268356685",
  instagram: "https://www.instagram.com/zalyas_ps/",
};

/**
 * الباقات. highlight يحدّد المختارة مسبقاً عند فتح صفحة الطلب — واحدة فقط،
 * فأول مطابقة هي ما يعيده defaultPack.
 */
export const PACKS = [
  {
    id: "single",
    name: "قطعة واحدة",
    tag: "",
    qty: 1,
    unitPrice: 149,
    highlight: true,
  },
  {
    id: "double",
    name: "قطعتين",
    tag: "الأكثر طلباً",
    qty: 2,
    unitPrice: 139,
    highlight: false,
  },
  {
    id: "triple",
    name: "ثلاث قطع",
    tag: "الأوفر",
    qty: 3,
    unitPrice: 126,
    highlight: false,
  },
];

/**
 * مناطق التوصيل وأجرتها. حلّت محل قائمة المدن المنسدلة: القائمة كانت تطلب
 * اختياراً بلا مقابل ظاهر للعميل، بينما هذه الأزرار الثلاثة تعرض الأجرة فوراً
 * فيرى تكلفته قبل أن يكمل — والمدينة تُكتب ضمن حقل العنوان.
 */
export const ZONES = [
  { id: "west-bank", name: "الضفة", fee: 0 },
  { id: "jerusalem", name: "القدس", fee: 10 },
  { id: "inside", name: "الداخل", fee: 50 },
];

export const packTotal = (pack) => pack.qty * pack.unitPrice;
export const packSaving = (pack) =>
  pack.qty * PRODUCT.oldPrice - packTotal(pack);
export const formatPrice = (value) => `${value} ${PRODUCT.currency}`;

export const defaultPack = PACKS.find((p) => p.highlight) ?? PACKS[0];
export const findPack = (id) => PACKS.find((p) => p.id === id) ?? defaultPack;
export const defaultZone = ZONES[0];
